import { fetchProductsFromFeed } from '../services/productFeedService';

// Fallback data for when the feed is not available
const fallbackData = [
  // Hot Wheels - Category 1
  {
    productId: 1,
    image: '/images/Bild1.jpg',
    productName: 'Hot Wheels Ferrari F40',
    brand: 'Hot Wheels',
    price: 29,
    originalPrice: 35,
    categoryId: 1,
    description: 'Klassisk röd Ferrari F40 i 1:64 skala. Perfekt för samlare och barn.',
    inStock: true,
    rating: 4.8,
    reviews: 124
  },
  {
    productId: 2,
    image: '/images/Bild2.jpg',
    productName: 'Hot Wheels Lamborghini Aventador',
    brand: 'Hot Wheels',
    price: 32,
    originalPrice: 38,
    categoryId: 1,
    description: 'Gul Lamborghini Aventador med detaljerad design och smidig rullning.',
    inStock: true,
    rating: 4.9,
    reviews: 89
  },
  {
    productId: 3,
    image: '/images/Bild3.jpg',
    productName: 'Hot Wheels Porsche 911 GT3',
    brand: 'Hot Wheels',
    price: 28,
    originalPrice: 33,
    categoryId: 1,
    description: 'Vit Porsche 911 GT3 med realistiska detaljer och premium finish.',
    inStock: true,
    rating: 4.7,
    reviews: 156
  },
  {
    productId: 4,
    image: '/images/Bild4.jpg',
    productName: 'Hot Wheels McLaren P1',
    brand: 'Hot Wheels',
    price: 35,
    originalPrice: 42,
    categoryId: 1,
    description: 'Orange McLaren P1 - en av de snabbaste bilarna i Hot Wheels samlingen.',
    inStock: false,
    rating: 4.9,
    reviews: 67
  },
  
  // LEGO - Category 2
  {
    productId: 5,
    image: '/images/Bild5.jpg',
    productName: 'LEGO Speed Champions Ferrari 488 GT3',
    brand: 'LEGO',
    price: 199,
    originalPrice: 249,
    categoryId: 2,
    description: 'Bygg din egen Ferrari 488 GT3 med 167 delar. Inkluderar minifigur.',
    inStock: true,
    rating: 4.8,
    reviews: 234
  },
  {
    productId: 6,
    image: '/images/Bild6.jpg',
    productName: 'LEGO Speed Champions Lamborghini Huracán',
    brand: 'LEGO',
    price: 179,
    originalPrice: 229,
    categoryId: 2,
    description: 'LEGO Lamborghini Huracán med 219 delar och detaljerad interiör.',
    inStock: true,
    rating: 4.9,
    reviews: 189
  },
  {
    productId: 7,
    image: '/images/Bild7.jpg',
    productName: 'LEGO Creator 3-in-1 Röd Racer',
    brand: 'LEGO',
    price: 149,
    originalPrice: 179,
    categoryId: 2,
    description: '3-in-1 set som kan byggas som racerbil, sportbil eller pickup.',
    inStock: true,
    rating: 4.6,
    reviews: 312
  },
  {
    productId: 8,
    image: '/images/Bild8.jpg',
    productName: 'LEGO Technic Bugatti Chiron',
    brand: 'LEGO',
    price: 899,
    originalPrice: 1099,
    categoryId: 2,
    description: 'Avancerad LEGO Technic Bugatti Chiron med 3599 delar och funktionella detaljer.',
    inStock: true,
    rating: 4.9,
    reviews: 45
  },
  
  // Siku - Category 3
  {
    productId: 9,
    image: '/images/Bild9.jpg',
    productName: 'Siku Mercedes-Benz Arocs',
    brand: 'Siku',
    price: 89,
    originalPrice: 109,
    categoryId: 3,
    description: 'Realistisk Mercedes-Benz Arocs lastbil i 1:50 skala med funktionella delar.',
    inStock: true,
    rating: 4.7,
    reviews: 78
  },
  {
    productId: 10,
    image: '/images/Bild10.jpg',
    productName: 'Siku BMW X5',
    brand: 'Siku',
    price: 45,
    originalPrice: 55,
    categoryId: 3,
    description: 'BMW X5 SUV med öppningsbara dörrar och detaljerad interiör.',
    inStock: true,
    rating: 4.5,
    reviews: 123
  },
  {
    productId: 11,
    image: '/images/Bild11.jpg',
    productName: 'Siku Volkswagen T6 California',
    brand: 'Siku',
    price: 65,
    originalPrice: 79,
    categoryId: 3,
    description: 'VW California campingbil med öppningsbara delar och campingutrustning.',
    inStock: true,
    rating: 4.8,
    reviews: 91
  },
  {
    productId: 12,
    image: '/images/Bild12.jpg',
    productName: 'Siku Porsche 911 Carrera S',
    brand: 'Siku',
    price: 55,
    originalPrice: 69,
    categoryId: 3,
    description: 'Elegant Porsche 911 Carrera S i metallisk silver med premium finish.',
    inStock: false,
    rating: 4.9,
    reviews: 67
  },
  
  // RC Cars - Category 4
  {
    productId: 13,
    image: '/images/Bild13.jpg',
    productName: 'RC Bil - Lamborghini Aventador',
    brand: 'Maisto',
    price: 299,
    originalPrice: 399,
    categoryId: 4,
    description: 'Radiostyrd Lamborghini Aventador med 2.4GHz fjärrkontroll och LED-belysning.',
    inStock: true,
    rating: 4.6,
    reviews: 34
  },
  {
    productId: 14,
    image: '/images/Bild24.jpg',
    productName: 'RC Bil - Ford Mustang GT',
    brand: 'Maisto',
    price: 249,
    originalPrice: 329,
    categoryId: 4,
    description: 'Radiostyrd Ford Mustang GT med realistiska ljud och rörelser.',
    inStock: true,
    rating: 4.7,
    reviews: 28
  }
];

// Main data function that tries to fetch from feed, falls back to static data
export const data = async () => {
  try {
    // Try to fetch real products from the feed
    const feedProducts = await fetchProductsFromFeed();
    if (feedProducts && feedProducts.length > 0) {
      console.log(`Loaded ${feedProducts.length} real products from Leksaksbilar.se feed`);
      return feedProducts;
    }
  } catch (error) {
    console.warn('Failed to load products from feed, using fallback data:', error);
  }
  
  // Fallback to static data
  console.log('Using fallback product data');
  return fallbackData;
};

// Synchronous version for backward compatibility
export const dataSync = () => {
  return fallbackData;
};

